import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path = "file-upload";
const path_handbook = "hand-book";

export interface fileUploadInterface {
  refId?: number;
  fileType?: string;
  file?: any
  files?: any
}

type delete_file_body = {
  refId: number;
  fileType: string;
  fileId?:number
}
export default class FileuploadApi extends BaseAPI {
  static uploadfile(props: any): Promise<any> {
    return this.api.post(path, props).then((res) => res);
  }

  static uploadfilearray(props: any): Promise<any> {
    return this.api.post(`${path}/multiple`, props).then((res) => res);
  }

  static uploadHandbook(props: any): Promise<any> {
    return this.api.post(`${path_handbook}`, props).then((res) => res);
  }

  static getUploadHandbook(refId: number): Promise<any> {
    return this.api.get(`${path_handbook}?refId=${refId}`).then((res) => res);
  }

  static downloadHandbook(idFile: number, props: any): Promise<any> {
    return this.api.get(`${path_handbook}/${idFile}/download-HandBook-file`,{
      params: { ...props },
      responseType: "arraybuffer",
    }
    ).then((res) => res);
  }


  static deleteFile(body:delete_file_body):Promise<AxiosResponse>{
    return this.api.patch(`${path}/delete`,body)
  }
}
